import { DistributionModeEnum } from '@/common/types/session'

export default Object.freeze({
  PULL_AUTO_ASSIGN: DistributionModeEnum.PULL_AUTO_ASSIGN,
  PULL_EXPLICIT_ASSIGN: DistributionModeEnum.PULL_EXPLICIT_ASSIGN,
  PUSH_ON_DEMAND: DistributionModeEnum.PUSH_ON_DEMAND,
  PUSH: DistributionModeEnum.PUSH,
})
